import type { ReactNode } from 'react';

import { Text, Heading } from '@sravni/react-design-system/lib/Typography';

import styles from './SeoStepCard.module.scss';

export function SeoStepCard({
  step,
  icon,
  title,
  description,
  actions,
}: {
  step?: number;
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text className={styles.step}>ШАГ {step}</Text>
        <div className={styles.headingContent}>
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.iconContainer}>{icon}</div>
        </div>
      </div>
      <div className={styles.content}>
        <Text className={styles.description}>{description}</Text>
      </div>

      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
